"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const PublisherAfterFindForm_1 = __importDefault(require("@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherAfterFindForm"));
const contexts_1 = require("@App/contexts");
const publisher_form_type_1 = require("@App/enum/publisher-form-type");
const PublisherAddForm_1 = __importDefault(require("@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherAddForm"));
const PublisherCreateForm_1 = __importDefault(require("@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherCreateForm"));
const AddOriginalPublisher = () => {
    const { workStore, publisherSearchStore, publisherStepStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const addPublisherToDraft = () => {
        publisherStepStore.addOriginalPublisherToDraft();
    };
    const setFinedPublisherToDraft = (publisher) => {
        workStore.setFoundOriginalPublisherToDraft(publisher);
    };
    const setOriginalPublisherData = (publisherData) => {
        publisherStepStore.setOriginalPublisherData(publisherData);
    };
    (0, react_1.useEffect)(() => () => {
        publisherSearchStore.clearStore();
        publisherStepStore.resetStore();
    }, []);
    switch (publisherStepStore.formType) {
        case publisher_form_type_1.PublisherFormType.add:
            return (react_1.default.createElement(PublisherAddForm_1.default, { setFoundPublisherToDraft: setFinedPublisherToDraft, topClass: "original-publisher-sub-form-component", title: "Add Publisher", subtitle: "First, search by publisher name to see if the publisher already exists in your catalog.", searchFilterPlaceholder: "Search publisher's name", suggestedTitle: "Pick from suggested publishers:", buttonText: "Create Publisher", isAdministrator: false }));
        case publisher_form_type_1.PublisherFormType.create:
            return (react_1.default.createElement(PublisherCreateForm_1.default, { publisherData: publisherStepStore.originalPublisherData, setPublisherData: setOriginalPublisherData, addPublisherToDraft: addPublisherToDraft, topClass: "original-publisher-sub-form-component", isAdministrator: false }));
        case publisher_form_type_1.PublisherFormType.afterFind:
            return (react_1.default.createElement(PublisherAfterFindForm_1.default, { setFinedPublisherToDraft: setFinedPublisherToDraft, addPublisherToDraft: addPublisherToDraft, topLevelClass: "original-publisher-sub-form-component" }));
        // I'm not sure why TS is requiring this default, all enums are accounted for in the switch
        default:
            return null;
    }
};
exports.default = (0, mobx_react_1.observer)(AddOriginalPublisher);
